import React from "react";
import { IResourceComponentsProps, BaseRecord } from "@refinedev/core";
import Cw8List from "components/cw8/Cw8List";
import { ConfigCard } from "interfaces/schemaDB";

export const PublicationsList: React.FC<IResourceComponentsProps> = () => {

    const resourceName :string = 'publication';

    const configCard : ConfigCard = {
        fieldTitle : "pub_title", 
        fieldDesc : "pub_title",
        fieldImg : "pub_coverImg"
    }


    return (
        <Cw8List
            resourceName = {resourceName}
            showCards = {true}
            configCard = {configCard}
        ></Cw8List>
    );
};
